import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from '../reservations';

type Variables = {
  id: number;
  endTime: string;
};
export type ExtendReservationResponse = {
  data: Reservation;
};

export const useExtendReservation = createMutation<
  ExtendReservationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/extend`,
      method: 'PUT',
      data: {
        end_time: variables.endTime,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.error);
      }),
});
